import {Deserializable} from "./deserializable.model";
import { BaseForm } from "./BaseForm"

export class LinkForm extends BaseForm{
    form_no:string;
    type:string = 'link';
    title:string;
    link:string;
    description:string;
}